<template>
<svg class="cnm-icon" width="65" height="66" viewBox="0 0 65 66" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M38 43.5293L28 33.373L38 23.2168" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<rect x="0.5" y="1.37305" width="64" height="64" stroke="#B1B1B1"/>
</svg>
</template>
